import { DOCUMENT } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  Renderer2,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-deceased-customer-modal',
  templateUrl: './deceased-customer-modal.component.html',
  styleUrls: ['./deceased-customer-modal.component.css']
})
export class DeceasedCustomerModalComponent implements OnChanges, OnDestroy {
  @Input() open = false;
  @Input() message = 'Lo sentimos, la cédula ingresada corresponde a una persona fallecida. ' +
    'Para más información, comuníquese con su asesor o con nuestro equipo de atención.';
  @Input() returnLabel = 'Regresar';

  @Output() openChange = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<void>();

  private previousBodyOverflow = '';
  private scrollLocked = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.open) {
      return;
    }

    if (this.open) {
      this.lockBodyScroll();
    } else {
      this.unlockBodyScroll();
    }
  }

  ngOnDestroy(): void {
    this.unlockBodyScroll();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapePressed(event: KeyboardEvent): void {
    if (!this.open) {
      return;
    }

    event.preventDefault();
    this.requestClose();
  }

  requestClose(): void {
    this.open = false;
    this.openChange.emit(false);
    this.closed.emit();
    this.unlockBodyScroll();
  }

  private lockBodyScroll(): void {
    if (this.scrollLocked || !this.document.body) {
      return;
    }

    this.previousBodyOverflow = this.document.body.style.overflow;
    this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
    this.scrollLocked = true;
  }

  private unlockBodyScroll(): void {
    if (!this.scrollLocked || !this.document.body) {
      return;
    }

    if (this.previousBodyOverflow) {
      this.renderer.setStyle(this.document.body, 'overflow', this.previousBodyOverflow);
    } else {
      this.renderer.removeStyle(this.document.body, 'overflow');
    }

    this.scrollLocked = false;
  }
}
